import { APIParameters, APIResult } from "common";
import { useEffect, useState } from "react";
import { APIQueryState } from "./useAPIQuery";

export const useOnAPISuccess = <T extends keyof APIParameters>({
  state,
  data,
  onSuccess,
}: {
  data: APIResult[T] | undefined;
  state: APIQueryState;
  onSuccess: (data: APIResult[T]) => void;
}) => {
  const [prevState, setPrevState] = useState<APIQueryState | undefined>(
    undefined
  );
  useEffect(() => {
    if (state === "success" && data && prevState !== "success") {
      onSuccess(data);
    }
    setPrevState(state);
  }, [state, data, onSuccess, prevState]);
};
